
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world",
      function () {
        return require("private-next-pages/world.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world"])
      });
    }
  